import { useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";

// table(components)

// boostraps
import OverlayTrigger from "react-bootstrap/OverlayTrigger";

// icons

// sub form
// redux
import { useDispatch, useSelector } from "react-redux";
import { setReminder } from "../../features/UserActions";

import { EngDateFormatNoSplit } from "../../core/ThaiDate";

import ConfirmDialog, { GetConfirmTitle } from "../components/ConfirmDialog";
import {
  ClearOldSession,
  EnumMessageType,
  EnumStudyID,
  GetDatePreriod,
  GetEnumValue,
} from "../../core/Helper";
import Loading from "../../components/Loading";
import MessageDialog from "../components/MessageDialog";
import { StudyService } from "../../model/study";
import { StudyMessageService } from "../../model/message-service";
import { encode } from "js-base64";
import { useNavigate } from "react-router-dom";
import { GetCreateTable } from "../../core/Helper2";
import {
  BuildContextItem,
  IconName,
} from "../technician/TechWorklist_MenuPopup";
import { getRadColumns } from "./RadioWorklist_Columns";
import RadioResult from "./RadioResult";
import ScreenCapture from "../technician/ScreenCapture";
import CapturedImageViewer from "../technician/CapturedImageViewer";
import SearchBrchGoodPopup from "../technician/SearchBrchGoodPopup";
import SearchBar, {
  convertParams,
  defaultStatusParams,
  GetInlineOptions,
} from "../components/A04_SearchBar";
import { WebSearchHelperService } from "../tools/search-helper";

// import TemplateEditorSaveAs from './TemplateEditorSaveas';

export default function RadioWorklist() {
  const userDetail = useSelector((state) => state.user.detail);
  const scrollTop = useSelector((state) => state.scrollTrack.value.scTop);
  const scrollLeft = useSelector((state) => state.scrollTrack.value.scLeft);
  const dispatch = useDispatch();
  // const [reqData, setReq] = useState([]);
  // const [waitData, setWait] = useState([]);
  const [allData, setAllData] = useState([]);
  // const [chart1, setChart1] = useState([
  //   { name: "เคสใหม่", value: 30 },
  //   { name: "ระหว่างวินิจฉัย", value: 10 },
  //   { name: "Finalized", value: 20 },
  // ]);
  const [showCtx, setShowCtx] = useState(false);
  const [showEditor, setShowEditor] = useState({ show: false });
  const [showScreenCapture, setShowScreenCapture] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [refData, setRefData] = useState([]);
  const [captureResult, setCaptureResult] = useState(false);
  const [searchA, setSearchA] = useState({ show: false, action: () => {} });
  const [searchB, setSearchB] = useState({ show: false, action: () => {} });
  const [showImageView, setShowImageView] = useState(false);
  const [searchGood, setSearchGood] = useState({
    show: false,
    aciton: () => {},
  });
  const [updateFlag, setUpdateFlag] = useState(true);
  const [params, setParams] = useState({
    goodcateid: -1,
    gdmodid: -1,
    gdspecialtyid: -1,
    gdspcsubid: -1,
    custid: -1,
    custid_sender: -1,
    brchpatrightid: -1,
    price_list_id: -1,
  }); //* parameters สำหรับค้นหาสินค้าด้วย รหัสสินค้ากับรหัสสิทธิรักษา  **/
  const [searchParams, setSearchParams] = useState(null);
  const [dateRangeValues, changeDateRange] = useState([new Date(), new Date()]);
  // const [templateEditor, setTemplateEditor] = useState({show:false})

  // Confirm
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);

  const [table1, setTable1] = useState();
  const [table2, setTable2] = useState();
  const [table3, setTable3] = useState();

  // keep all context menu
  const [contextMenuList, setContextMenuList] = useState();

  // selectionMode

  const [dateSelected, setDateSelected] = useState(1);
  const [remainJob, setRemainJob] = useState(0);
  const [mouseXY, setMouseXY] = useState([0, 0]);

  const [msgBox, setMsgBox] = useState({
    show: false,
    title: "แจ้งเตือน",
    message: "ไม่พบข้อมูลคนไข้",
    type: EnumMessageType.ERROR,
  });

  const [criteria, setCriteria] = useState("");

  //** Parameter from query string */
  // const queryParams = useLocation().search;
  // const id = new URLSearchParams(queryParams).get("aaa");

  const refMouse = useRef();

  const [loading, setLoading] = useState(false);

  const [statusParam, setStatusParam] = useState(defaultStatusParams);

  // F
  const handleContextMenu = (e) => {
    if (selectedRow !== null) {
      setShowCtx(true);
    }
    e.preventDefault();
  };

  useEffect(() => {
    if (showEditor.show === false) {
      getData(true);
    }
  }, [dateRangeValues, criteria]);

  const navigate = useNavigate();

  // ---------------------------------------------------------------------
  useEffect(() => {
    if (showEditor.show === false) {
      document.addEventListener("contextmenu", handleContextMenu);
    } else {
      document.removeEventListener("contextmenu", handleContextMenu);
    }

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, [showEditor, selectedRow]);
  // ---------------------------------------------------------------------
  useEffect(() => {
    if (updateFlag) {
      getData(true);
      setUpdateFlag(false);
    }
  }, [updateFlag]);
  // ---------------------------------------------------------------------

  useEffect(() => {
    const intervalId = setInterval(() => {
      console.log("interval working ....");
      // console.log(selectedRow);
      if (showEditor.show === false) {
        getData(false);
      }
    }, 60000);
    return () => {
      clearInterval(intervalId);
    };
  }, [showEditor, selectedRow, dateRangeValues]);

  // ** receive study components data {patient-right, }..
  useEffect(() => {
    getComponent();
  }, []);

  const getComponent = async () => {
    let ret = await StudyService.GetStudyComponents({
      BrchId: userDetail.brchid,
    });
    if (ret != null) {
      setRefData(ret);
    } else {
      remindError("Error loading study components");
    }
  };

  useEffect(() => {
    let counter = 0;

    for (let i = 0; i < allData?.length; i++) {
      if (allData[i]?.diag_finish == "n") {
        counter++;
      }
    }
    setRemainJob(counter);
  }, [allData]);

  useEffect(() => {
    refMouse.current.style.left = `${scrollLeft + mouseXY[0] - 7}px`;
    refMouse.current.style.top = `${scrollTop + mouseXY[1] - 7}px`;
  }, [mouseXY]);

  // const buildTable = (state, data) => {
  //   const getColumn = async () => {
  //     let cols = await GetRadiWorkListColumn();
  //     const [tb, setTb] = state;
  //     setTb(
  //       GetCreateTable({
  //         ...{
  //           idFieldName: "pacs_study_id",
  //           columns: cols,
  //           data: data,
  //         },
  //         ...{ selectRow, defaultSorted, rowEvents, defaultSorted },
  //       })
  //     );
  //   };
  //   getColumn();
  // };

  /** Build Menu-Context */
  const getContextItem = () => {
    let item = [
      {
        icon: IconName.RADI_ACCEPT_CASE,
        hidden: selectedRow?.rad_accepted === "y",
        onClick: () => actionAccept(selectedRow),
      },
      {
        icon: IconName.RADI_REJECT_CASE,
        hidden: selectedRow?.rad_accepted === "y",
        onClick: () => rejectStudy(),
      },
      {
        icon: IconName.RADI_DIAG_REPORT,
        hidden:
          selectedRow?.rad_accepted === "y" &&
          selectedRow?.rad_resulted === "y",
        onClick: () => showEditorAction(),
      },
      {
        icon: IconName.RADI_EDIT_REPORT,
        hidden: selectedRow?.diag_official === "n",
        onClick: () => showEditorAction(),
      },
      {
        icon: IconName.CANCEL_STUDY,
        hidden: selectedRow?.rad_accepted === "n",
        onClick: () => rejectStudy("ยืนยันการยกเลิกเคส"),
      },
      { icon: IconName.RETURN_NOACTION, onClick: () => setShowCtx(false) },
    ];
    return item;
  };

  useEffect(() => {
    const getMenu = async () => {
      let item = getContextItem();
      let ret = await BuildContextItem(item);
      setContextMenuList(ret);
    };
    getMenu();
    // return () => setContextMenuList(null);
  }, [selectedRow]);

  //** build table All-Study */
  useEffect(() => {
    setTable1(
      GetCreateTable({
        idFieldName: "pacs_study_id",
        columns: getRadColumns(),
        data: allData ?? [],
        selectRow,
        defaultSorted,
        rowEvents,
        defaultSorted,
      })
    );

    // return () => {
    //   setTable1(null);
    // };
  }, [allData]);
  // refMouse.current?.style?.top

  //** build table Request New incoming */
  // useEffect(() => {
  //   if (ctxMode === "wait") {
  //     buildTable([table2, setTable2], reqData);
  //     return () => setTable2(null);
  //   }
  // }, [reqData, ctxMode]);
  // refMouse.current?.style?.top

  //** build table in-diagnosis */
  // useEffect(() => {
  //   if (ctxMode === "work") {
  //     buildTable([table3, setTable3], waitData);
  //     return () => setTable3(null);
  //   }
  // }, [waitData, ctxMode]);
  //refMouse.current?.style?.top
  useEffect(() => {
    setPreriod("LAST7DAYS", 2);
  }, []);

  //--- Event สำหรับ เปิดภาพจากการคลิกที่ "tab การแจ้งเตือน"
  const openCaseFromNotifier = (e) => {
    getSingleStudy(e.detail.studyId, e.detail.messageId, (data) => {
      setSelectedRow(data.rows[0]);
      //** รับเคสแล้วไม่ต้องแจ้ง Admin อีก */
      if (data?.rows[0]?.rad_accepted === "n") {
        actionAccept(data.rows[0], () => {
          showEditorAction();
        });
      } else {
        showEditorAction();
      }
    });
  };

  //** event listener when clicked from notification slider */
  useEffect(() => {
    document.addEventListener("openStudyFromNotifyBox", openCaseFromNotifier);
    checkOpenStudyFromSession();
    return () => {
      document.removeEventListener(
        "openStudyFromNotifyBox",
        openCaseFromNotifier
      );
    };
  }, []);

  //** เช็คการเปิดจาก app อื่น เช่น link ผ่านไลน์ */
  const checkOpenStudyFromSession = async () => {
    let pacsStudyId = sessionStorage.getItem("radconn_pacs_study_id");
    let radStaffId = sessionStorage.getItem("radconn_staff_id");
    let paramType = sessionStorage.getItem("radconn_param_type");
    let messageId = sessionStorage.getItem("message_id");

    if (messageId) {
      let ret = await StudyMessageService.CheckRadioValidMessage({
        MessageId: messageId,
        UserInfo: encode(JSON.stringify(userDetail)),
      });

      if (!ret.messageValid) {
        setMsgBox({
          show: true,
          title: "Invalid LINE Message",
          message: (
            <div style={{ color: "#f02906" }}>
              <div>ข้อความนี้ไม่มีผลใช้งานแล้ว</div>
              <div>กรุณาติดต่อแอดมิน</div>
              <div>จึงเรียนขออภัยมา ณ ที่นี้</div>
              <div>{ret?.studyInfo?.Radiologist?.FullFirstName}</div>
            </div>
          ),
          type: EnumMessageType.ERROR,
        });

        ClearOldSession();
        return;
      }
    }

    if (paramType === "radaction_accepted") {
      if (pacsStudyId && radStaffId) {
        if (userDetail.staffid == radStaffId) {
          getSingleStudy(pacsStudyId, messageId, (data) => {
            if (data != null) {
              setSelectedRow(data.rows[0]);
              //** รับเคสแล้วไม่ต้องแจ้ง Admin อีก */
              if (data?.rows[0]?.rad_accepted === "n") {
                actionAccept(data.rows[0], () => {
                  showEditorAction();
                });
              } else {
                showEditorAction();
              }
            }
          });
        }
      }
      ClearOldSession();
    }
    if (paramType === "admin_verify_case") {
      navigate("/home");
    }
  };

  // ---------------------------------------------------------------------
  const getData = async (showLoading) => {
    console.log("check criteria ...", criteria);
    setLoading(showLoading);

    // let ret = await StudyService.GetStudyListForRadi({
    //   UserInfo: userDetail,
    //   DateRange: [
    //     EngDateFormatNoSplit(dateRangeValues[0]),
    //     EngDateFormatNoSplit(dateRangeValues[1]),
    //   ],
    //   SearchInfo: searchParams,
    // });

    let sql = `call sp_getstudy_list_radiologist_ont(${userDetail.staffid},
    ${userDetail.brchid}, 
    '${EngDateFormatNoSplit(dateRangeValues[0] ?? new Date())}',
         '${EngDateFormatNoSplit(dateRangeValues[1] ?? new Date())}',
          '${criteria ?? ""}', '${convertParams(statusParam)}', 0
          );`;

    let ret = await WebSearchHelperService.GetBasicDataset(
      {
        text: null,
        root: null,
        sql: encode(sql),
      },
      userDetail
    );

    if (ret != null) {
      // setReq(ret.row_request);
      // setWait(ret.row_wait);
      setAllData(ret?.[0]);

      //   setChart1([
      //     { name: "เคสใหม่", value: ret.row_request.length || 0 },
      //     { name: "ระหว่างวินิจฉัย", value: ret.row_wait.length || 0 },
      //     {
      //       name: "Finalized",
      //       value:
      //         ret.row_all.length -
      //         ((ret.row_wait.length || 0) + (ret.row_request.length || 0)),
      //     },
      //   ]);
      // } else {
      // remindError("Study not found.");
    }
    setLoading(false);
  };
  //** Get Single Study */
  const getSingleStudy = async (pacsStudyId, messageId, callback) => {
    let ret = await StudyService.GetSingleStudyRadi({
      UserInfo: userDetail,
      StudyInfo: pacsStudyId,
      MessageId: messageId,
    });
    if (ret != null) {
      callback(ret);
    } else {
      callback(null);
      remindError({
        message: "ไม่สามารถเปิดเคสได้ เนื่องจากข้อความหมดอายุการใช้งาน",
      });
    }
  };
  // ---------------------------------------------------------------------
  const remindError = (msg) => {
    dispatch(setReminder({ show: true, message: msg.message, type: "error" }));
  };

  const defaultSorted = [
    {
      dataField: "action_dt",
      order: "desc",
    },
    {
      dataField: "action_dt2",
      order: "desc",
    },
  ];

  // --------------------------------------
  const showEditorAction = () => {
    setShowEditor({ show: true });
    setShowCtx(false);
  };

  const confirmReceiveStatus = async (row) => {};
  //** ยืนยันการรับเคส */
  const actionAccept = async (row, nextAction) => {
    setShowCtx(false);
    setLoading(true);

    let ret = await StudyService.UpdateStudyStatus({
      StudyInfo: row,
      StatusInfo: GetEnumValue(EnumStudyID, EnumStudyID.RAD_ACCEPTED),
      UserInfo: userDetail,
      MessageId: 0,
    });

    if (ret != null) {
      setUpdateFlag(true);
      setLoading(false);
      if (!nextAction) {
        //confirm การรับเคส
        confirmReceiveStatus(row);
        dispatch(
          setReminder({
            show: true,
            message: "ยืนยันการรับเคสแล้ว",
            type: "success",
          })
        );
      } else {
        nextAction();
      }
    } else {
      setLoading(false);
      dispatch(
        setReminder({
          show: true,
          message: "ไม่สามารถยืนยันการับเคสได้",
          type: "error",
        })
      );
    }
  };

  //** ปฏิเสธเคส */ --------------------------------------
  const rejectStudy = (message) => {
    setShowCtx(false);
    setShowConfirm(true);
    setConfirmAction({
      title: message ?? GetConfirmTitle("REJECT_CASE"),
      data: selectedRow,
      action: async (row) => {
        let ret = await StudyService.UpdateStudyStatus({
          StudyInfo: row,
          StatusInfo: GetEnumValue(EnumStudyID, EnumStudyID.RAD_REJECTED),
          UserInfo: userDetail,
        });
        if (ret != null) {
          setUpdateFlag(true);
          dispatch(
            setReminder({
              show: true,
              message: "ยืนยันการปฏิเสธเคสแล้ว",
              type: "success",
            })
          );
        } else {
          dispatch(
            setReminder({
              show: true,
              message: ret?.message,
              type: "error",
            })
          );
        }
      },
    });
  };

  const UpdateMouseCursor = (e) => {
    if (e.clientX) {
      setMouseXY([e.clientX, e.clientY]);
    }
  };

  const UpdateSelectedRow = (row) => {
    setSelectedRow(row);
  };

  const selectRow = {
    mode: "radio",
    clickToSelect: true,
    classes: "row-h-over-selected",
    hideSelectColumn: true,
    onSelect: (row, isSelect, rowIndex, e) => {
      UpdateMouseCursor(e);
      UpdateSelectedRow(row);
    },
  };
  // --------------------------------------
  const AutoAcceptCase = (row) => {
    confirmReceiveStatus(row);
    if (selectedRow?.rad_accepted === "n") {
      actionAccept(row ?? selectedRow, () => {
        showEditorAction();
      });
    } else {
      showEditorAction();
    }
  };

  const rowEvents = {
    onClick: (e, row) => {
      UpdateMouseCursor(e);
      UpdateSelectedRow(row);
    },
    onDoubleClick: (e, row) => {
      AutoAcceptCase(row);
    },
    onMouseEnter: (e, row) => {
      setShowCtx(false);
      UpdateSelectedRow(row);
      UpdateMouseCursor(e);
    },
    onMouseMove: (e) => {
      refMouse.current.style.left = `${e.clientX - 7}px`;
    },
    onMouseDown: (e) => {
      UpdateMouseCursor(e);
    },
  };

  const setPreriod = (dateStyle, index) => {
    changeDateRange(GetDatePreriod(dateStyle));
    setDateSelected(index);
  };

  useEffect(() => {
    // console.log(convertParams(statusParam));
    getData();
  }, [statusParam]);

  return (
    <MainContainer>
      {loading ? <Loading /> : <></>}

      <OverlayTrigger
        show={showCtx}
        placement="right"
        overlay={contextMenuList}
      >
        <MotionBox ref={refMouse} />
      </OverlayTrigger>
      <SearchBar
        inlineOption={useMemo(
          () => (
            <GetInlineOptions
              {...{
                statusParam,
                setStatusParam,
                isDoctor: true,
              }}
            />
          ),
          [statusParam]
        )}
        callback={(e) => {
          setCriteria(e.info);
          changeDateRange(e.dateRange);
        }}
      />

      <TableContainer>{table1}</TableContainer>

      {/* <TemplateEditorSaveAs {...{winState:[templateEditor, setTemplateEditor]}} />  */}
      <ConfirmDialog
        {...{ showConfirm, setShowConfirm, confirmAction, setConfirmAction }}
      />

      <MessageDialog
        {...{
          param: [msgBox, setMsgBox],
        }}
      />
      <RadioResult
        {...{
          editor: [showEditor, setShowEditor],
          userDetail,
          selectedRow: [selectedRow, setSelectedRow],
          showCtx: [showCtx, setShowCtx],
          refData,
          showScreenCapture,
          setShowScreenCapture,
          searchState: [searchA, setSearchA],
          showImage: [showImageView, setShowImageView],
          searchGood: [searchGood, setSearchGood],
          searchB: [searchB, setSearchB],
          params: [params, setParams],
          updateFlag: [updateFlag, setUpdateFlag],
          enableSave: true,
          enablePrint: false,
          loading: [loading, setLoading],
          // template:[templateEditor, setTemplateEditor]
        }}
      />
      <ScreenCapture
        {...{
          showScreenCapture,
          setShowScreenCapture,
          userDetail,
          selectedRow,
          setCaptureResult,
        }}
      ></ScreenCapture>
      <CapturedImageViewer
        {...{ showImage: [showImageView, setShowImageView] }}
      />
      <SearchBrchGoodPopup
        {...{
          winState: [searchGood, setSearchGood],
          params: [params, setParams],
        }}
      />
    </MainContainer>
  );
}

const TableContainer = styled.div`
  box-shadow: var(--shadow-panel);
  border-radius: 12px;
  background: white;
`;

const MotionBox = styled.div`
  position: absolute;
  top: 100px;
  left: 100px;
  height: 15px;
  width: 15px;
  background-color: transparent;
  z-index: -10;
`;

const MainContainer = styled.div`
  padding: 30px;
  background-color: var(--body-background);
`;
